<template>
  <div class="answer">
    <div class="content">
      <div class="text">
        <h6>{{ answerNum + 1 }}、{{ nowAnswer.title }}</h6>
        <div
          v-for="(item, index) in nowAnswer.answers"
          :key="index"
          class="option"
          @click="checkAnswer(item, index)"
          ref="option"
        >
          <div class="result" v-if="checkFlag == index">
            <van-icon
              name="success"
              v-if="nowAnswer.ok == item.answer"
              color="green"
            />
            <van-icon
              name="cross"
              v-if="nowAnswer.ok != item.answer"
              color="red"
            />
          </div>
          {{ item.answer }}：{{ item.answer_desc }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "answer",
  data() {
    return {
      data: [],
      paper: [],
      answerNum: 0,
      correctNum: 0,
      checkFlag: null,
      nowAnswer: {
        title: "",
      },
    };
  },
  mounted() {
    this.getPrize();
  },
  methods: {
    getPrize() {
      this.$axios({
        methods: "get",
        url: "http://wstq.scimall.org/api/Djdt/jhzs8",
        data: {},
      })
        .then((res) => {
          this.data = res.data.lists;
          this.nowAnswer = this.data[this.answerNum];
        })
        .catch((err) => {});
    },
    checkAnswer(item, index) {
      if (this.checkFlag == null) {
        this.checkFlag = index;
        this.$refs.option[index].style.backgroundImage =
          "url('" + require("../assets/xuanxiang1.png") + "')";
        if (item.answer == this.nowAnswer.ok) {
          this.correctNum++;
        }
        this.paper.push({
          id: this.nowAnswer.id,
          answer: item.answer,
        });
        if (this.answerNum < this.data.length - 1) {
          setTimeout(() => {
            this.$refs.option[index].style.backgroundImage =
              "url('" + require("../assets/xuanxiang.png") + "')";
            this.answerNum++;
            this.nowAnswer = this.data[this.answerNum];
            this.checkFlag = null;
          }, 1000);
        } else {
          setTimeout(() => {
            if (this.correctNum == this.data.length) {
              this.$router.push({
                path: "/result",
                query: {
                  result: "true",
                  paper: this.paper,
                },
              });
            } else {
              this.$router.push({
                path: "/result",
                query: {
                  result: "false",
                  paper: this.paper,
                },
              });
            }
          }, 1000);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.answer {
  width: 100%;
  height: 100%;
  position: relative;
  .content {
    position: absolute;
    top: 15vh;
    width: 100%;
    height: 115vw;
    background-image: url("../assets/answer.png");
    background-size: 100% 100%;
    .text {
      width: 56%;
      margin: 35vw auto;
      text-align: center;
      display: block;
      h6 {
        margin: 0;
        padding: 0;
        font-size: 4vw;
        color: #964221;
        margin-bottom: 5vh;
      }
      .option {
        color: #ffffff;
        font-size: 3.9vw;
        font-weight: 600;
        width: 80%;
        margin: 2vh auto;
        padding: 1vh 0;
        text-align: center;
        background-image: url("../assets/xuanxiang.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: relative;
        .result {
          font-size: 3.9vw;
          line-height: 30px;
          width: 30px;
          height: 30px;
          // background: aqua;
          position: absolute;
          left: -30px;
        }
      }
      p {
        color: #a66652;
        font-size: 3.9vw;
        text-align: left;
        font-weight: 600;
        padding-left: 3vw;
        margin: 5vw 0;
      }
    }
  }
}
</style> 



// WEBPACK FOOTER //
// src/pages/answer.vue